import React, { Fragment } from 'react';

// import { DodgeFront } from '../../../../images/UberTorontoLinks';
import { GoFrontView } from '../../../../images/LandingPageNYC/NYCImageLinks';

import offerIcon from '../../../../images/Icons/offer-icon.svg';
import trainingIcon from '../../../../images/Icons/training-icon.svg';
import feesIcon from '../../../../images/Icons/fees-icon.svg';
import bonusIcon from '../../../../images/Icons/bonus-icon.svg';

import Heading from '../Shared/Heading';
import WhyDrive from '../Shared/WhyDrive';
import FleetFaq from '../Shared/FleetFaq';
import WhyWait from '../Shared/WhyWait';
import NYCFooter from '../../../Layout/NYCFooter';

import ScrollLock from 'react-scrolllock';

import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const GoContainer = () => (
  <Fragment>
    <ScrollLock>
      <div className="landing__scroll">
        <Heading
          header="Autzu GO"
          price="$7"
          notes={['Guaranteed Earnings', 'Great Benefits']}
          image={GoFrontView}
          icon={<FontAwesomeIcon icon={faCircle} fixedWidth size="1x" />}
        />
        <WhyDrive header="Why Autzu GO?" cards={cardContent} pro={false} />
        <FleetFaq faqContent={faqContent} />
        <WhyWait />
        <NYCFooter />
      </div>
    </ScrollLock>
  </Fragment>
);

export default GoContainer;

const cardContent = [
  {
    icon: offerIcon,
    title: 'Earn more',
    text:
      'Driving Autzu GO automatically makes you eligible for ViaBlue, which means that Via will guarantee a fixed hourly rate as long as you are online.'
  },
  {
    icon: trainingIcon,
    title: 'Comfort and Class',
    text:
      'Not only will passengers enjoy the spacious seating and luxurious leather interior, but you can feel satisfied with world class vehicle handling and a smooth ride.'
  },
  {
    icon: feesIcon,
    title: 'Improved Hourly Rate',
    text:
      'Maximize the time you have in an Autzu GO vehicle with unlimited access to ViaBlue, which provides guaranteed hourly rates.'
  },
  {
    icon: bonusIcon,
    title: 'Extra Incentives',
    text:
      'Get a $500 signup bonus from Via to be used towards your first 2 weeks of bookings on Autzu GO.*'
  }
];

const faqContent = [
  {
    title: 'What is Autzu GO?',
    text:
      'Autzu GO is our fleet of luxurious Mercedes Benz Metris. We cover maintenance, licencing, cleaning, insurance, parking and provide 24/7 emergency support. Autzu GO vehicles allow you to be eligible for ViaBlue, which are guaranteed hourly rates.'
  },
  {
    title: 'What is Via?',
    text:
      'Via is a technology platform which matches multiple riders that are going in the same direction with vehicles following optimized roads to maximize efficiency and quality of service. As a Via driver-partner, you use Autzu’s vehicles to pick up riders and drive them to preferred destinations in your city.',
    link: {
      text: 'To learn more, visit',
      title: 'www.ridewithvia.com.',
      href: 'https://www.ridewithvia.com'
    }
  },
  {
    title: 'Do I have to pay a deposit or any money upfront?',
    text:
      'Setting up an Autzu account is totally free and there are no hidden fees. You are not required to make any financial commitments to begin!'
  }
];



// WEBPACK FOOTER //
// ./src/components/Static/NYCFleets/AutzuGo/GoContainer.js